export default __webpack_public_path__ + "static/media/upward-arrow-icon.dab0a0f3.svg";